module.exports = __webpack_public_path__ + "media/images/favicon-16x16-d674ecb0fdf723b5dec595a2ccfad0b5.png";